import { Injectable } from '@angular/core';
import { IAttachment } from '@common/interfaces/attachment';
import { ID } from '@common/interfaces/id';
import { QueryConfig, QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';
import { AttachmentStore, AttachmentState } from './attachment.store';
import { ascSort, sortByCreatedAt } from '@ep-om/utils/sort';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: (a: { createdAt: string }, b: { createdAt: string }) => sortByCreatedAt(a, b)(ascSort)
})
export class AttachmentQuery extends QueryEntity<AttachmentState> {
  constructor(protected store: AttachmentStore) {
    super(store);
  }

  public selectByIssueId$(issueId: ID): Observable<IAttachment[]> {
    return this.selectAll({
      filterBy: [
        attachment => attachment.issueId === issueId
      ]
    })
  }

  public getByIssueId(issueId: ID): IAttachment[] {
    return this.getAll({
      filterBy: [
        attachment => attachment.issueId === issueId
      ]
    })
  }

  selectAttachmentsByFileName(photoNames: string[]): Observable<IAttachment[]> {
    return (this.selectAll({
      filterBy: [
        attachment => photoNames ? photoNames.includes(attachment.fileName) : false,
        attachment => !attachment.hidden
      ]
    }))
  }

  getByFileName(fileName: string): IAttachment[] {
    return (this.getAll({
      filterBy: [
        attachment => attachment.fileName.includes(fileName)
      ]
    }))
  }

  selectByFileName$(fileName: string): Observable<IAttachment[]> {
    return (this.selectAll({
      filterBy: [
        attachment => attachment.fileName.includes(fileName)
      ]
    }))
  }

  getByInterfaceId(interfaceId: string): IAttachment[] {
    return (this.getAll({
      filterBy: [
        attachment => attachment.interfaceId === interfaceId
      ]
    }))
  }

  selectByInterfaceId$(interfaceId: string): Observable<IAttachment[]> {
    return this.selectAll({
      filterBy: [
        attachment => attachment.interfaceId == interfaceId
      ]
    })
  }
}
